import React, { useCallback } from 'react';

import ArrowRight from '@mui/icons-material/ArrowRight';

import PlayerButton from 'components/buttons/PlayerButton';
import { type MuiSelectProps } from 'components/selectors/tmxSelector/TMXSelect';
import { type ParticipantInterface } from 'typedefs/store/tmxTypes';

interface ChoosePlayerSelectProps extends Omit<MuiSelectProps, 'onClick'> {
  participantId: string;
  name: string;
  onClick: (
    e: React.MouseEvent<HTMLButtonElement>,
    participant: Pick<ParticipantInterface, 'participantId' | 'participantName'>,
  ) => void;
}

const ChoosePlayerSelect: React.FC<React.PropsWithChildren<ChoosePlayerSelectProps>> = React.memo(
  ({ participantId, name, onClick }) => {
    const handleClick = useCallback(
      (e: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(e, { participantId, participantName: name });
      },
      [onClick, participantId, name],
    );

    return (
      <PlayerButton key={participantId} endIcon={<ArrowRight />} onClick={handleClick}>
        {name}
      </PlayerButton>
    );
  },
);

export default ChoosePlayerSelect;
